  (function () {
    function addResetButton() {
      const addToCartBtn = document.querySelector('.mw-apo-add-to-cart-custom');
      const mwApoContainer = document.querySelector('.mw-apo-container');

      if (!addToCartBtn || !mwApoContainer) return false;

      if (!document.querySelector('.mw-apo-actions')) {
        const resetBtn = document.createElement('button');
        resetBtn.type = 'button';
        resetBtn.className = 'mw-apo-reset-button';
        resetBtn.textContent = 'Reset Options';

        resetBtn.addEventListener('click', function () {
          if (window.metaboxConfigurator && window.metaboxConfigurator.reset) {
            window.metaboxConfigurator.reset();
          }

          const checkedRadios = Array.from(mwApoContainer.querySelectorAll('input[type="radio"]:checked'));
          const checkedCheckboxes = Array.from(mwApoContainer.querySelectorAll('input[type="checkbox"]:checked'));

          const checkedInputs = [...checkedRadios, ...checkedCheckboxes];

          if (checkedInputs.length === 0) return;

          checkedInputs.forEach((input) => {
            const label = mwApoContainer.querySelector(`label[for="${input.id}"]`);
            if (label) {
              label.click();
            } else {
              input.click();
            }
          });

          const helpTextElements = mwApoContainer.querySelectorAll('.mw-option__helptext');
          helpTextElements.forEach((helptext) => {
            helptext.classList.add('mw-hidden');
          });
        });

        const actions = document.createElement('div');
        actions.className = 'mw-apo-actions';
        actions.appendChild(resetBtn);

        mwApoContainer.appendChild(actions);
      }

      return true;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    function init() {
      const resetInterval = setInterval(() => {
        if (addResetButton()) {
          clearInterval(resetInterval);
        }
      }, 500);
    }
  })();